export default {
  iconSize: '22px'
}
